import React from "react";
import { Sparkles, Leaf } from "lucide-react";

const RemedyShareCard = React.forwardRef(function RemedyShareCard(
  { result, topRemedy, note, instagramHandle },
  ref
) {
  if (!result || !topRemedy) return null;

  return (
    <div
      ref={ref}
      style={{
        width: 360,
        height: 640,
        position: "fixed",
        top: 0,
        left: -9999,
        fontFamily: "'Outfit', sans-serif",
      }}
      className="bg-[#0B302F] text-[#FDFBF7] relative overflow-hidden flex flex-col"
    >
      <div
        className="absolute -top-16 -left-16 w-56 h-56 rounded-full bg-[#2A5C5A]"
        style={{ filter: "blur(50px)", opacity: 0.7 }}
      />
      <div
        className="absolute bottom-10 -right-20 w-64 h-64 rounded-full bg-[#D5B876]"
        style={{ filter: "blur(60px)", opacity: 0.25 }}
      />
      <div
        className="absolute top-1/2 left-1/2 w-72 h-72 rounded-full bg-[#F9EAE8]"
        style={{ filter: "blur(70px)", opacity: 0.08, transform: "translate(-50%, -50%)" }}
      />

      <div className="relative flex flex-col h-full px-8 py-9">
        <div className="flex items-center gap-2.5">
          <div className="h-9 w-9 rounded-full bg-[#D5B876]/15 border border-[#D5B876]/40 flex items-center justify-center">
            <Leaf className="h-4 w-4 text-[#D5B876]" strokeWidth={1.6} />
          </div>
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif" }} className="text-lg leading-none">
              Bloom &amp; Heal
            </div>
            <div className="text-[8px] tracking-[0.24em] uppercase text-[#D5B876]/80 mt-0.5">
              Bach Flower Remedies
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center text-center gap-5 -mt-6">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-[#D5B876]/40 text-[9px] tracking-[0.24em] uppercase text-[#D5B876]">
            <Sparkles className="h-3 w-3" strokeWidth={1.6} />
            Find Your Remedy
          </div>

          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-[#FDFBF7]/60 mb-2">
              {result.title}
            </div>
            <div
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              className="text-5xl italic tracking-tight text-[#F9EAE8] leading-[1.05]"
            >
              {topRemedy.name}
            </div>
          </div>

          <p className="text-sm text-[#FDFBF7]/75 leading-relaxed max-w-[260px]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {note}
          </p>
        </div>

        <div className="flex flex-col items-center gap-1 pt-4 border-t border-[#FDFBF7]/15">
          <div className="text-[9px] tracking-[0.22em] uppercase text-[#FDFBF7]/50">
            Take the quiz at
          </div>
          <div className="text-[11px] tracking-[0.14em] text-[#D5B876]">{instagramHandle}</div>
        </div>
      </div>
    </div>
  );
});

export default RemedyShareCard;
